// RefundDetails.js
import "./RefundDetails.css"; // Import CSS file for styling
import React, { useEffect, useState } from "react";
import { useLoader } from "../../../../base/context/LoaderProvider";
import {
  ToastTypes,
  useMessage,
} from "../../../../base/context/MessageProvider";
import { orderApiService } from "../../../../service/admin/ordersApiService";
import { useNavigate, useParams } from "react-router-dom";

const RefundDetails = () => {
  const [data, setData] = useState(null);
  const loader = useLoader();
  const message = useMessage();
  const navigate = useNavigate();
  const orderId = useParams();
  useEffect(() => {
    if (orderId?.id) {
      fetchAllOrders();
    }
  }, [orderId?.id]);

  const fetchAllOrders = () => {
    loader.showLoading(true);
    orderApiService
      .getRefundedByOrderId(orderId.id)
      .then((res) => {
        loader.showLoading(false);
        if (res.status.code === 200) {
          setData(res.data);
        } else if (res.status.code === 404) {
          setData(null);
        } else if (res.status.code === 402) {
          navigate("/login");
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        loader.showLoading(false);
        message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
      });
  };

  if (!data) {
    return (
      <div className="refund-page-empty">
        <p>No refund data available.</p>
      </div>
    );
  }

  const details = [
    { label: "Order ID", value: data.displayOrderId || "-" },
    { label: "Importerr Order ID", value: data.upsaleoOrderId || "-" },
    { label: "Seller Email", value: data.sellerEmail || data.sellerId || "-" },
    { label: "Refunded By", value: data.refundedByEmail || "-" },
    { label: "Amount", value: data.amount != null ? `${data.amount}` : "-" },
    { label: "Reason", value: data.reason || "-" },
    { label: "Refund Status", value: data.refundStatus || "-" },
  ];

  return (
    <div className="refund-details-page">
      <div className="refund-details-card">
        <div className="refund-details-header">
          <h2>Refund Details</h2>
          <span className={`refund-status-chip ${String(data.refundStatus || "").toLowerCase()}`}>
            {data.refundStatus || "Unknown"}
          </span>
        </div>

        <div className="refund-details-grid">
          {details.map((item) => (
            <div className="refund-detail-item" key={item.label}>
              <p className="refund-detail-label">{item.label}</p>
              <p className="refund-detail-value">{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RefundDetails;
